var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.quicks.QUICKS && _vm.quicks.QUICKS.length > 0
    ? _c("div", { attrs: { id: "catalogQuickstations" } }, [
        _c("div", { staticClass: "question-tab-h" }, [
          _vm._v("\n         Вопросы о товаре "),
          _c("span", { staticClass: "count-question-tab-h" }, [
            _vm._v(" " + _vm._s(_vm.quicks.QUICKS.length) + " "),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "quickstations", class: { "hide-q": _vm.show } },
          _vm._l(_vm.quicks.QUICKS, function (quick) {
            return _vm.quicks
              ? _c(
                  "div",
                  { staticClass: "question-tab-item" },
                  [
                    _c("div", { staticClass: "question-tab-item-h" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "question-tab-fl" }, [
                      _c("div", { staticClass: "question-tab-user-name-sel" }, [
                        _vm._v(
                          "\n                                                  " +
                            _vm._s(quick.UF_NAME) +
                            "\n                                                "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "question-tab-item-date" }, [
                        _vm._v(
                          "\n                                                  " +
                            _vm._s(quick.UF_DATE) +
                            "\n                                                "
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "question-tab-user-sel-discr" }, [
                      _vm._v(
                        "\n                                              " +
                          _vm._s(quick.UF_QUICK) +
                          "\n                                            "
                      ),
                    ]),
                    _vm._v(" "),
                    _vm._l(quick.RESPONSES, function (response) {
                      return _c(
                        "div",
                        { staticClass: "question-tab-user-sel" },
                        [
                          _c("div", { staticClass: "question-tab-fl-sel" }, [
                            _c(
                              "div",
                              { staticClass: "question-tab-user-name-sel" },
                              [
                                _vm._v(
                                  "\n                                                              " +
                                    _vm._s(response.UF_NAME) +
                                    "\n                                                        "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "question-tab-item-date" },
                              [
                                _vm._v(
                                  "\n                                                          " +
                                    _vm._s(response.UF_DATE) +
                                    "\t\n                                                        "
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "question-tab-user-sel-discr" },
                            [
                              _vm._v(
                                "\n                                                      " +
                                  _vm._s(response.UF_TEXT) +
                                  "\t\n                                                    "
                              ),
                            ]
                          ),
                        ]
                      )
                    }),
                  ],
                  2
                )
              : _vm._e()
          }),
          0
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "show-more-question",
            class: { "hide-b": !_vm.show },
            on: { click: _vm.showQuick },
          },
          [
            !_vm.show
              ? _c("span", [_vm._v("Показать больше вопросов")])
              : _vm._e(),
            _vm._v(" "),
            _vm.show ? _c("span", [_vm._v("Скрыть вопросы")]) : _vm._e(),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }